export const obj2Array = (obj) => Object.entries(obj).map(([, item]) => item)

export const array2Obj = (array, id='id', removeId=false) => {
  const final = {}
  array.forEach(a => {
    const aid = a[id]
    if (removeId) delete a.id
    final[aid] = a
  })
  return final
}

export const sortObjs = (array, field, desc) => {
  let list = array
  list.sort(function(a, b) { 
    return desc ? b[field] - a[field] : a[field] - b[field]
  })
  return list
}

export const formatPhoneNumber = (phoneNumber) => {
  let phone = phoneNumber.replace(/\D/g,'')
  if (phone.length == 11 && phone.charAt(0) == '1') phone = phone.substring(1)
  return phone
}

// Strips special characters and keeps only the last 10 digits, so DNIS values arriving with
// country codes, punctuation, or extra leading junk still compare equal to a bare 10-digit number.
export const last10Digits = (value) => String(value ?? '').replace(/\D/g, '').slice(-10)

// TLD letters-only so trailing digits (e.g. phone fragment) are rejected
export const isValidEmail = (email) => {
  if (!email || typeof email !== 'string') return false
  const trimmed = email.trim()
  return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(trimmed)
}

const escapeHtml = (s) =>
  String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// Render a cash_subscriptions.previous_retention string as bolded HTML for the
// "already retained" display. Handles every shape without crashing:
//   offer:      'Retention offer "X" accepted on <date> by <name>. Reason: <r>'
//   value-save: 'Value-based save accepted on <date> by <name>. Reason: <r>'
//   refund:     'Refund Requested on <date> by <name>. Reason: <r>'  (no ' accepted')
// The result is rendered with v-html, and the string contains free-form text
// (agent-entered reasons / refund comments), so the dynamic parts are escaped
// while the structural <span>/<br> markup is kept literal.
export const formatRetentionSummary = (previousRetention) => {
  if (!previousRetention) return null
  const [desc, reasonPart] = previousRetention.split('. Reason:')
  let headline = desc
  let acceptedLine = ''
  if (desc.includes(' accepted')) {
    const [label, rest] = desc.split(' accepted')
    headline = label.replace('Retention offer ', '')
    acceptedLine = `Accepted${rest}`
  }
  const parts = [`<span class="text-h5 font-weight-bold">${escapeHtml(headline)}</span>`]
  if (acceptedLine) parts.push(escapeHtml(acceptedLine))
  if (reasonPart) parts.push(`Reason:${escapeHtml(reasonPart)}`)
  return parts.join('<br><br>')
}

export const delay = (ms=1000) => new Promise(resolve => setTimeout(resolve, ms))

// Recognized AI-chat session_source values — mirrors ai-shield's
// ALLOWED_SESSION_SOURCE_NAMES (handlers.py) minus "retell": "chat" is the
// canonical name going forward, "aichat"/"botpress" cover the AI-platform and
// legacy Botpress orchestrators respectively. Single source of truth for "is this
// a chat channel" — session_source is the canonical signal, not which URL param
// name a session id happened to arrive under (see SearchForm.vue's
// processScreenPopFromUrl and zendeskTickets.js's createPhoneTicket/
// logTransferredLegComment, both of which key off this).
export const CHAT_SESSION_SOURCES = new Set(['botpress', 'aichat', 'chat'])
export const isChatSessionSource = (sessionSource) => CHAT_SESSION_SOURCES.has(sessionSource)